import { render, staticRenderFns } from "./UserInput.vue?vue&type=template&id=22012273&scoped=true"
import script from "./UserInput.vue?vue&type=script&lang=js"
export * from "./UserInput.vue?vue&type=script&lang=js"
import style0 from "./UserInput.vue?vue&type=style&index=0&id=22012273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22012273",
  null
  
)

export default component.exports